/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendWorkingCapitalParameterDto } from '../../models/backend-working-capital-parameter-dto';
import { BackendWorkingCapitalParameterRequestDto } from '../../models/backend-working-capital-parameter-request-dto';

export interface FinancingSourcesWorkingCapitalParametersUpdate$FormData$Params {
  /**
   * A unique integer value identifying this working capital parameter.
   */
  id: number;
  body: BackendWorkingCapitalParameterRequestDto;
}

export function financingSourcesWorkingCapitalParametersUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params: FinancingSourcesWorkingCapitalParametersUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendWorkingCapitalParameterDto>> {
  const rb = new RequestBuilder(rootUrl, financingSourcesWorkingCapitalParametersUpdate$FormData.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendWorkingCapitalParameterDto>;
    }),
  );
}

financingSourcesWorkingCapitalParametersUpdate$FormData.PATH =
  '/api/financing_sources/working_capital_parameters/{id}/';
